export default class WorkCompletionApproval {
  scheduleId: string;
  workDate: string;
  workTime: string;
  workSupervisor: string;
  facilityName: string;
  workContents: string;
  approversList: Array<{
    approverName: string;
    approverRollId: string;
    approverUserId: string;
    approvalStatus: string;
    approverSort: number;
  }>;
  sasimodosuReason: string;
  approvalComment: string;
  constructor(
    scheduleId = "",
    workDate = "",
    workTime = "",
    workSupervisor = "",
    facilityName = "",
    workContents = "",
    approversList = [],
    sasimodosuReason = "",
    approvalComment = ""
  ) {
    this.scheduleId = scheduleId;
    this.workDate = workDate;
    this.workTime = workTime;
    this.workSupervisor = workSupervisor;
    this.facilityName = facilityName;
    this.workContents = workContents;
    this.approversList = approversList;
    this.sasimodosuReason = sasimodosuReason;
    this.approvalComment = approvalComment;
  }
}
